<template>
  <div class="contentGlobal extra">
    <b-button-group class="menuListTop">
      <b-button class="menuTop" style="margin:0px;" @click="viewMode = 'table'" :pressed="viewMode=='table'">
        <icon name="list"></icon>
      </b-button>
      <b-button v-if="!hideSlide" class="menuTop" style="margin:0px;" @click="viewMode = 'slide'" :pressed="viewMode=='slide'">
        <icon name="desktop"></icon>
      </b-button>
      <b-button class="menuTop" style="margin:0px;" @click="viewMode = 'grid'" :pressed="viewMode=='grid'">
        <icon name="th-large"></icon>
      </b-button>
    </b-button-group>
    <div v-if="viewMode == 'table'" style="margin:15px">
      <div class="int pTop">
        <b-col cols="3" class="inputSearch">
                <b-input-group>
                    <b-form-input v-model="filter" :placeholder="$t('messages.typeToSearch')" />
                    <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"> <icon name="times-circle"></icon></b-btn>
                    </b-input-group-append>
                </b-input-group>
        </b-col>
        <div style="height:400px;">
          <b-row class="pt-4" cols="12">
            <b-table  ref="table" head-variant="light" hover
              :fields="fields"
              :items="pools"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :sort-compare="sortCompare"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
              >
              <template v-slot:cell(actions)="{ value, item }">
                  <router-link class="btnTable" :to="`/detail/${item.id}`"><icon name="eye"></icon> </router-link> 
                  <router-link class="btnTable" :to="`/pool-detail/${item.id}`"> <icon name="edit"></icon>  </router-link>
                  <b-btn v-b-modal.unsubscribe @click="selectedPoolId = item.id" class="btnTable"><icon name="trash"></icon></b-btn>
              </template>
              <template  #cell(main)="{ value }">
                {{ getTemp(value) }}
              </template>
              <template slot="id" slot-scope="row">
                {{ row.item.id }}
              </template>


              <template #cell(form.name)="row">
                {{ (hasCustomName(row.item.form)) }}
              </template>

              <template  #cell(present)="{ value }">
                <span v-bind:class="(value)?'green':'red'">{{ (value) ? $t("messages.yes") : $t("messages.no") }}</span>
              </template>

              <template #cell(main.localTime)="{ value }">
                {{ $moment.unix(value).utc().format("DD-MM-YYYY HH:mm") }}
              </template> 
              <template #cell(filtration)="{ value }">
                {{ getFiltrationMode(value.mode) }} -
                <span v-bind:class="(value.status === 1)?'green':'red'">{{ (value.status === 1) ? "ON" : "OFF" }}</span>
              </template>

              <template #cell(updatedAt)="{ value }">
                {{ value | moment("DD-MM-YYYY HH:mm:ss") }}
              </template>

              <template v-slot:cell(light)="{ value, item }">
                {{ getLightMode(value.mode) }} -
                <span v-bind:class="(value.status === 1)?'green':'red'">{{ (value.status === 1) ? "ON" : "OFF" }}</span>
              </template>

              <template  #cell(main.RSSI)="{ value }">
                <span v-bind:class="( getRSSI(value) )"> {{ value < 0 ? value +' dBm': 'N/A' }} </span>
              </template>
            </b-table>
          </b-row>
          <b-row align-h="center">
            <b-pagination class="pagination" :total-rows="getTotalRows" :per-page="perPage" v-model="currentPage"/>
          </b-row>
        </div>
      </div>
    </div>

    <div class="content inner" v-else-if="viewMode == 'slide'">
      <div class="int" v-if="!hideSlide">
        <b-container fluid>
          <div class="slider w100">
            <b-carousel v-if="pools.length"
              id="carousel1"
              controls
              indicators
              img-width="1024"
              img-height="150"
              :interval="40000000"
              v-model="slide"
            >
              <b-carousel-slide v-for="pool in pools" :key="pool.reference">
                <pool-global :pool="pool" mode="slide"></pool-global>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </b-container>
      </div>
    </div>
    <div class="content inner double" v-else>
      <div class="int pTop">
        <b-container fluid>
          <div class="slider">
            <b-col cols="12">
              <b-row align-h="center">
                <div v-for="pool in listPools" :key="pool.reference" class="blockPool">
                  <pool-global :pool="pool"></pool-global>
                </div>
              </b-row>
              <b-row align-h="center">
                <b-pagination :total-rows="getTotalRows"  v-model="currentPage" :per-page="perPage" />
              </b-row>
            </b-col>
            
          </div>
        </b-container>

      </div>
    </div>

    <b-modal id="unsubscribe" ref="modal">
        <b-container>
            <p> {{ $t("messages.poolUnsubscribe") }} : <strong>{{ selectedPoolId }} </strong>? </p>
        </b-container>
        <div slot="modal-footer" >
            <button class="float-right btn btnPerso delete" @click="onUnsubscribe()">
                {{ $t("messages.remove") }}
            </button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PoolGlobal from "./Pool";

export default {
  name: "dashboard",
  components: {
    PoolGlobal
  },
  data() {
    return {
      main:null,
      msg: "",
      viewMode: "slide",
      hideSlide: false,
      slide: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      currentPage: 1,
      perPage: 10,
      filter: null,
      totalRows: 0,
      selectedPoolId: null,
      currentPage: 1,
      perPage: 15,
      fields: [
        // Node ID, Name, Temperature, Filtration, Lighting, Local time, Updated at, Actions
        {key: "id",label: this.$i18n.t("messages.nodeID"),t: "messages.nodeID",sortable: true,shortcode: "pn"},
        {key: "form.name",label: this.$i18n.t("messages.login.name"),t: "messages.login.name",sortable: true},
        {key: "present",label: this.$i18n.t("messages.connected"),t: "messages.connected",},
        {key: "main",label: this.$i18n.t("messages.temperature"),t: "messages.temperature"},
        {key: "filtration",label: this.$i18n.t("messages.filtration"),t: "messages.filtration"},
        {key: "light",label: this.$i18n.t("messages.lighting"),t: "messages.lighting"},
        {key: "main.localTime",label: this.$i18n.t("messages.localTime"),t: "messages.localTime"},
        {key: "updatedAt",label: this.$i18n.t("messages.updatedAt"),t: "messages.updatedAt"},
        {key: "main.RSSI",label:"Wifi RSSI"},
        {key: "actions",label: this.$i18n.t("messages.actions"),t: "messages.actions"}
      ]
    };
  },
  watch: {
    "$i18n.locale": function(oldV, newV) {
      this.resetColumns();
    },
    
    userProfile: function(val){
      if(this.userProfile && this.userProfile.pools.length > 15){
        this.viewMode = "table"
        this.hideSlide = true
      }
    },
  },
  mounted(){
    try{
      if(this.userProfile && this.userProfile.pools.length > 15){
        this.viewMode = "table"
        this.hideSlide = true
      }
    }catch(e){
      console.log('no pools ');

    }

  },
  computed: {
    ...mapState(["currentUser", "pools", "userProfile"]),



    getTotalRows(){
      return this.pools.length
    },
    listPools() {
      const items = this.pools

      // Return just page of items needed
      return items.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      )
    },
  },
  methods: {
    hasCustomName(item){
      console.log('item table', item);
      try {
      if(item.names && item.names.length > 0){
        for (var uid of Object.keys(item.names)) {
         //if(this.currentUser.uid == item.names[uid].user){
          return item.names[uid].name
        //} 
        }
      }
      return item.name
      } catch(error) {
      return  '';
      }
    },
    getFiltrationMode(val) {
      var _str = "messages."+this.$store.getters.getFiltrationMode(val).toLowerCase();
      return this.$t(_str).toUpperCase();
    },
    getTemp(val) {
      try{
        return (val.hideTemperature==0) ? val.temperature+' Cº' : '--'
      }catch(err){

      } 
    },
    onUnsubscribe(){
        if(this.selectedPoolId) {
            this.$refs.modal.hide()
            var index = this.userProfile.pools.findIndex(x => x === this.selectedPoolId);
            if(index >=0){
              this.userProfile.pools.splice(index,1);
            }
            var index = this.pools.findIndex(x => x.id === this.selectedPoolId);
            if(index >=0){
              this.pools.splice(index,1);
            }
            this.$store.dispatch('unsubscribe', {id: this.selectedPoolId})
            this.$snotify.async( '', '',() => new Promise((resolve, reject) => {
                this.$store.dispatch('updateUser', {
                    'id': this.userProfile.id, 
                    'fields': {'pools':this.userProfile.pools}
                }).then(response => {
                resolve({body: this.$t('messages.login.requestSuccess'),
                        config: {
                            timeout: 2000,
                            closeOnClick: true
                        }
                    })
                }, error => {
                    reject({body: this.$t('messages.login.requestFailed'),
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        }
    },
    resetColumns() {
     if(!this.$refs.table) return 
      this.$refs.table.fields.forEach(column => {
        if (column.t) {
          column.label = this.$i18n.t(column.t);
        }
      });
    },
    getRSSI(val) {
      var _val = Math.abs(val);
      if(_val> 0 && _val<=58){
        return "green"
      }else if(_val >58 && _val < 68){
        return "orange"
      }else if(_val >= 68){
        return "red"
      }else{
        return "grey"
      }
    },
    getLightMode(val) {
      var value = "";
      switch (val) {
        // MAN, AUTO
        case 0:
          value = "MANUAL";
          break;
        case 1:
          value = "AUTO";
          break;
        default:
          value = "MAN";
          break;
      }
      return value;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    sortCompare(a, b, key) {
      if (key === "main.localTime.seconds") {
        var a = a.main.localTime.seconds;
        var b = b.main.localTime.seconds;
        if (a < b) {
          return 1;
        } else if (a > b) {
          return -1;
        } else if (a == b) {
          return 0;
        }
      } else if (key === "form.reference") {
        if (a.form.reference < b.form.reference) {
          return 1;
        } else if (a.form.reference > b.form.reference) {
          return -1;
        } else if (a.form.reference == b.form.reference) {
          return 0;
        }
      } else if (key === "form.name") {
        if (a.form.name < b.form.name) {
          return 1;
        } else if (a.form.name > b.form.name) {
          return -1;
        } else if (a.form.name == b.form.name) {
          return 0;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue